import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { ShortcutModel } from "../models/shortcut.model";
import { Observable, of, take, tap } from "rxjs";

@Injectable()
export class ShortcutService {

    private userShortcuts: ShortcutModel[];

    constructor(private api: ApiService) {
        this.userShortcuts = [];
    }

    public getUserShortcuts(): Observable<ShortcutModel[]> {
        if (this.userShortcuts == null || this.userShortcuts.length === 0) {
            return this.getUserShortcutsFromServer();
        } else {
            return of(this.userShortcuts);
        }
    }

    private getUserShortcutsFromServer() {
        return this.api.get<ShortcutModel[]>('shortcut/get').pipe(
            take(1),
            tap((shortcuts: ShortcutModel[]) => {
                this.userShortcuts = shortcuts;
            })
        );
    }
}